import * as actions from './actionTypes';
// import {NavLink, Link} from 'react-router-dom';
import Config from '../config';
import {Base64} from '../assets/Base64';
// import React from 'react';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {getItem, setItem, setItems, keys} from "../localStorage";
import {debug, find} from "../utility/functions";
import {RESET_REDUX_STATES} from "./actionTypes";
import * as urls from '../api';


const crypto = require('crypto');

const requestInit = (method, body = null, auth = true) => {
    const h = {
        method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    };
    if (body !== null) h.body = JSON.stringify(body);
    if (auth) h.headers['Authorization'] = getItem(keys.tokenType) + ' ' + getItem(keys.accessToken);
    return h;
};

const urlWithParams = (url, params) => {
    if(params === undefined) {
        return url;
    }
    Object.keys(params).forEach((value, index) => {
        if(!url.includes("?")) {
            url += "?" + value + "=" + params[value]
        } else {
            url += "&" + value + "=" + params[value]
        }
    });
    return url;
};

export function encrypt(text) {
    const cipher = crypto.createCipher(Config.algorithm, Config.AES_KEY);
    let crypted;
    switch (typeof text) {
        case "string":
            crypted = cipher.update(String(text), 'utf8', 'hex');
            break;
        case "boolean":
            crypted = cipher.update(Boolean(text), 'utf8', 'hex');
            break;
        default:
            crypted = cipher.update(String(text), 'utf8', 'hex');
    }
    crypted += cipher.final('hex');
    return Base64.encode(crypted);
}

export function decrypt(text) {
    var decipher = crypto.createDecipher(Config.algorithm, Config.AES_KEY);
    var dec = decipher.update(Base64.decode(String(text)), 'hex', 'utf8');
    dec += decipher.final('utf8');
    return dec;
}

export const autoLogin = (postData) => {
    debug("Fetching '" + Config.urlApi + urls.AUTHENTICATE + "'");
    debug("postData -> ", postData);
    return fetch(Config.urlApi + urls.AUTHENTICATE, requestInit("POST", postData, false))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .then(response => {
            setItems(response.data);
            setItem(keys.loggedIn, true);
        })
        .catch(handleCatch)
};

export const login = (postData) => {
    postData['grant_type'] = 'password';
    postData['client_id'] = 'app_web';
    postData['client_secret'] = 'token-hand5-4Luge';
    debug("Fetching '" + Config.urlApi + urls.AUTHENTICATE + "'");
    return fetch(Config.urlApi + urls.AUTHENTICATE, requestInit("POST", postData, false))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .then(response => {
            setItems(response.data);
            setItem(keys.personal_data, postData);
            setItem(keys.loggedIn, true);
            debug("Success", response);
            alertSuccess('Login efectuado com sucesso!');
            return response;
        })
        .catch(handleCatch)
};

// Request to Get all Schools

export const getSchools = () => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOLS + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOLS, requestInit("GET", null, false))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch)
};

export const getLayouts = () => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_LAYOUTS + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_LAYOUTS, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const getSchoolArticleLayouts = () => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLE_LAYOUTS + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_ARTICLE_LAYOUTS, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);

};

export const editLayout = (layout) => {
    debug("Fetching '" + Config.urlApi + urls.EDIT_SCHOOL_LAYOUT + "'");
    return fetch(Config.urlApi + urls.EDIT_SCHOOL_LAYOUT, requestInit("POST", layout))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Request to Get all Classes for this school
export function getClasses(url) {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_CLASSES + "'");
    return fetch(url ? url : Config.urlApi + urls.GET_SCHOOL_CLASSES, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
}

// Request to Add a Class for this school
export const addClasses = (body) => {
    body['school_id'] = getItem(keys.schoolId);
    debug("Fetching '" + Config.urlApi + urls.CREATE_SCHOOL_CLASS + "'");
    return fetch(Config.urlApi + urls.CREATE_SCHOOL_CLASS, requestInit("POST", body))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Request to Get a specific class in the school
export const getClass = (id) => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_CLASS + id + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_CLASS + id, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Request to edit a class
export const editClass = (id, body) => {
    debug("Fetching '" + Config.urlApi + urls.EDIT_SCHOOL_CLASS + id + "'");
    return fetch(Config.urlApi + urls.EDIT_SCHOOL_CLASS + id, requestInit("POST", body))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Request to remove a class
export const removeClass = (id) => {
    debug("Fetching '" + Config.urlApi + urls.REMOVE_SCHOOL_CLASS + id + "'");
    return fetch(Config.urlApi + urls.REMOVE_SCHOOL_CLASS + id, requestInit("DELETE"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const getArticle = (id) => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLE + id + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_ARTICLE + id, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Request to Get all articles to a specific school
export const getArticles = (url)  => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLES + "'");
    return fetch(url ? url : Config.urlApi + urls.GET_SCHOOL_ARTICLES, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);

};

export const getPendingArticles = (url) => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLES_PENDING + "'");
    return fetch(url? url : Config.urlApi + urls.GET_SCHOOL_ARTICLES_PENDING, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const getScheduledArticles = () => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLES_SCHEDULED + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_ARTICLES_SCHEDULED, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const getPublishedArticles = (url) => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_ARTICLES_PUBLISHED + "'");
    return fetch(url? url : Config.urlApi + urls.GET_SCHOOL_ARTICLES_PUBLISHED, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const createArticle = (article) => {
    debug("Fetching '" + Config.urlApi + urls.CREATE_SCHOOL_ARTICLE + "'");
    return fetch(Config.urlApi + urls.CREATE_SCHOOL_ARTICLE, requestInit("POST", article))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const editArticle = (id, article) => {
    debug("Fetching '" + Config.urlApi + urls.EDIT_SCHOOL_ARTICLE + id + "'");
    return fetch(Config.urlApi + urls.EDIT_SCHOOL_ARTICLE + id, requestInit("POST", article))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const removeArticle = (article) => {
    debug("Fetching '" + Config.urlApi + urls.REMOVE_SCHOOL_ARTICLE + article.id + "'");
    return fetch(Config.urlApi + urls.REMOVE_SCHOOL_ARTICLE + article.id, requestInit("DELETE"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Fetch all multimedia files related to your authentication token

export const getAllMultimedia = (url, params = {}) => {
    debug("Fetching '",Config.urlApi, urls.GET_SCHOOL_FILES, params, "'");
    return fetch(urlWithParams(url? url : Config.urlApi + urls.GET_SCHOOL_FILES, params), requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Create a new file in multimedia

export const createMultimedia = (file) => {
    debug("Fetching '" + Config.urlApi + urls.CREATE_SCHOOL_FILE + "'");
    debug("Body -> ", file);
    return fetch(Config.urlApi + urls.CREATE_SCHOOL_FILE, requestInit("POST", file))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Edit a file in multimedia

export const editMultimedia = (id, file) => {
    debug("Fetching '" + Config.urlApi + urls.EDIT_SCHOOL_FILE + "'");
    return fetch(Config.urlApi + urls.EDIT_SCHOOL_FILE + id, requestInit("POST", file))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

// Remove a file from multimedia

export const removeMultimedia = (id) => {
    debug("Fetching '" + Config.urlApi + urls.REMOVE_SCHOOL_FILE + id + "'");
    return fetch(Config.urlApi + urls.REMOVE_SCHOOL_FILE + id, requestInit("DELETE"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

export const getMultimedia = (id) => {
    debug("Fetching '" + Config.urlApi + urls.GET_SCHOOL_FILE + id + "'");
    return fetch(Config.urlApi + urls.GET_SCHOOL_FILE + id, requestInit("GET"))
        .then(handleRequestErrors)
        .then(response => response.json())
        .then(handleResponseErrors)
        .catch(handleCatch);
};

const handleRequestErrors = (request) => {
    debug("Request -> ", request);
    if(request.status === 200) return request;

    if(request.url.includes("/api/schools/accessToken/")){
        if(request.status === 401) {
            alertUnauthorized("Utilizador ou Senha incorretos!");
        }
    }

    return Promise.reject(request.statusText)
};

const handleResponseErrors = (response) => {
    debug("Response -> ", response);
    if(response.status === 200) return response;
    if(response.error) {
        return Promise.reject(response.error)
    }

    if(response.errors) {
        return Promise.reject("Existem Parâmetros por preencher")
    }

    return response.message;

};

const handleCatch = (error) => {
    debug("Catch -> ", error);
    if(error === "Failed to fetch") {
        alertError("O servidor não se encontra disponível, tente mais tarde");
    }

    return Promise.reject(error);
};

export const logoutOauth = () => dispatch => {
    localStorage.clear();
    dispatch({type: RESET_REDUX_STATES});
    dispatch({type: actions.VALIDATE_OAUTH_FAILURE})
};

export const editorHasText = (body) => {
    try {
        return body !== null
    } catch (e) {
        return false;
    }
};


// alerts

export function alertSuccess(message) {
    toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT
    });
}

export function alertUnauthorized(message) {
    toast.warn(message, {
        position: toast.POSITION.BOTTOM_RIGHT
    });
}

export function alertError(message) {
    toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT
    });
}

export function alertInfo(message) {
    toast.info(message, {
        position: toast.POSITION.BOTTOM_RIGHT
    });
}
